module.exports = __webpack_public_path__ + "img/solucion o aceite ingerible en ampoyeta.d2ab6e2e.png";